import { Fragment, useContext } from 'react';
import { match } from 'ts-pattern';

import DialogContainer from '~/domains/design-system/components/Dialog/DialogContainer';
import useAnimatedDialogModals from '~/domains/common/context/useAnimatedDialogModals';
import TooManyAttemptsModal from '~/domains/auth/components/TooManyAttemptsModal/TooManyAttemptsModal';
import ExistingAccountModal from '~/domains/auth/components/ExistingAccountModal/ExistingAccountModal';

import { AuthModalsContext } from './AuthModalsContext';

function AuthModals() {
  const { modals } = useContext(AuthModalsContext);
  const { modalsCache, activeModal, closingModal } = useAnimatedDialogModals({
    modals,
  });

  return (
    <DialogContainer
      isOpen={!!modals.length}
      onClose={undefined}
      lockScroll
    >
      {modalsCache.map((modal) => {
        const isOpen = activeModal === modal && closingModal !== modal;

        return (
          <Fragment key={modal.type}>
            {match(modal)
              .returnType<React.ReactNode>()
              .with({ type: 'TooManyAttemptsModal' }, (rest) => (
                <TooManyAttemptsModal {...rest} isOpen={isOpen} />
              ))
              .with({ type: 'ExistingAccountModal' }, (rest) => (
                <ExistingAccountModal {...rest} isOpen={isOpen} />
              ))
              .otherwise(() => null)}
          </Fragment>
        );
      })}
    </DialogContainer>
  );
}

export default AuthModals;
